import React from "react";
import { Tag } from "@chakra-ui/react";
import { AiOutlineCheckCircle, AiOutlineFieldTime } from "react-icons/ai";

interface TagGeracaoContaRecorrenteProps {
  gerada: boolean;
}

function TagGeracaoContaRecorrente({ gerada }: TagGeracaoContaRecorrenteProps) {
  return (
    <Tag
      rounded="full"
      gap="4px"
      variant="outline"
      colorScheme={gerada ? "green" : "purple"}
      textAlign="center"
    >
      {gerada ? <AiOutlineCheckCircle /> : <AiOutlineFieldTime />}{" "}
      {gerada ? "Gerada" : "Não gerada"}
    </Tag>
  );
}

export default TagGeracaoContaRecorrente;
